import React from "react";
import "./project.css";

import { FiGithub } from "react-icons/fi";
import { MdOutlineLiveTv } from "react-icons/md";
let nat4;

function Project(props) {
  const colorListCss = {
    blue: `linear-gradient(to right bottom,rgb(80, 105, 189),rgb(33, 67, 180))`,
    green: `linear-gradient(to right bottom,rgba(126, 213, 111),rgba(40, 180, 133))`,
    red: `linear-gradient(to right bottom, rgb(214, 93, 103),rgb(245, 50, 66))`,
    main: `linear-gradient(to bottom, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 1) 100%)`,
  };

  return (
    <div className="tour__main--container w-[min(25rem,100%)] ">
      <div className="tour__container--front bg-containerColor dark:bg-darkContainerColor ">
        <div
          className="tour__img h-60"
          style={{
            backgroundImage: `${colorListCss["main"]},url(${props.tour__img})`,
          }}
        ></div>
        <div className="tour__content relative">
          <div className="tour__heading left-0 -top-8 -translate-y-full ">
            <span className="tour__heading--span rounded-r-xl section__subtitle shadow-lg  bg-containerColor dark:bg-darkContainerColor border-2 border-leetcodeBorderColor border-l-0 ">
              {props.tour__heading}
            </span>
          </div>
          <div className="flex flex-col gap-2 justify-center items-center px-2 section__content relative">
            <span className="text-center ">{props.description}</span>
            <span className="section__contentSubTitle dark:text-white border-b-[2px] border-leetcodeBorderColor pb-1 px-4 ">
              Features
            </span>
            <ul className=" flex flex-col  justify-center list-[circle] ">
              {props.features.map((item) => (
                <li>{item}</li>
              ))}
            </ul>
            <span className="section__contentSubTitle dark:text-white border-b-[2px] border-leetcodeBorderColor pb-1 px-4 ">
              Stack
            </span>
            <div className="flex gap-2 pt-2 flex-wrap">
              {props.stack.map((item) => (
                <span className="py-1 px-3  rounded-full border-[1px] shadow-md border-leetcodeBorderColor capitalize">
                  {item}
                </span>
              ))}
            </div>
            <div className="absolute right-3 -bottom-12">
              <span className="text-firstColor text-2xl animation-state-running ">
                {">"}
              </span>
              <span className="text-firstColor text-2xl animate-pulse">
                {">"}
              </span>
              <span className="text-firstColor text-2xl animate-pulse ">
                {">"}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="tour__container--back bg-containerColor dark:bg-darkContainerColor overflow-clip gap-4">
        <div className="h-[50%] w-full">
          <iframe
            width="100%"
            height="100%"
            src={props.youtubeURL}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
        <span className=" section__content text-justify p-4">
          {props.detailedDescription}
        </span>
        <div className="flex pb-4  p-2 justify-around items-start w-full">
          <a
            href={props.liveURL}
            className="flex justify-center items-center gap-2 py-3 px-8  rounded-xl border-[1px] shadow-md border-leetcodeBorderColor capitalize hover:-translate-y-[2px] transition-transform lg:cursor-pointer "
          >
            Live
            <MdOutlineLiveTv />
          </a>
          <a
            href={props.githubURL}
            className="flex justify-center items-center gap-2 py-3 px-8  rounded-xl border-[1px] shadow-md border-leetcodeBorderColor capitalize hover:-translate-y-[2px] transition-transform lg:cursor-pointer "
          >
            Github
            <FiGithub />
          </a>
        </div>
      </div>
    </div>
  );
}
Project.defaultProps = {
  tour__img: nat4,
  tour__color: "red",
  tour__heading: "the sea explorar",
  tour__list: [
    "3 day tour",
    "upto 30 peoples",
    "2 tour guides",
    "sleep in cozy hostel",
    "difficult:easy",
  ],
  tour__price: 320,
};
export default Project;
